

import { Component, VModel, Emit, Mixins } from 'vue-property-decorator';
import IBDialog from '@/components/Dialog/IBDialog.vue';
import IBButton from '@/components/IBButton/IBButton.vue';
import auth from '@/models/modules/auth';
import CustomerActivitySettings from '../mixins/CustomerActivitySettings';

@Component({
	components: {
		IBDialog,
		IBButton
	}
})
export default class CustomerSessionExpiredDialog extends Mixins(
	CustomerActivitySettings
) {

	@VModel({ type: Boolean })
	model!: boolean

	redirectToAuth() {
		this.model = false;

		this.signOutAndRedirectToAuth();
	}

	signOutAndRedirectToAuth() {
		auth.signOutAndRedirectToAuth();
	}

	@Emit('re-auth')
	emitReAuth() {}

}
	
